// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".parent-info-card-doc-v2__title{display:none;margin-bottom:21px;font-weight:600;font-size:22px;line-height:100%;letter-spacing:-.02em;color:var(--tm-text-color)}@media(max-width:1023px){.parent-info-card-doc-v2__title{margin-bottom:10px;margin-left:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
